<template>
  <el-dialog
    title="跟进记录"
    width="50%"
    :visible.sync="diaVisible"
    append-to-body
    @close="handleClose()"
  >
    <div style="text-align: right; margin-bottom: 20px;">
      <crm-button
        v-if="auth.govProjectRecordAdd && auth.govProjectRecordAdd.toggleStatus"
        :size="'mini'"
        :text="'新增一列'"
        @click="handleAdd()"
      >
      </crm-button>
    </div>
    <el-table
      :data="list"
      border
      v-loading="loading"
      fit
      height="400px"
      style="width: 100%"
    >
      <el-table-column
        show-overflow-tooltip
        prop="content"
        label="跟进信息"
        align="center"
      >
        <template slot-scope="{ row }">
          <el-input
            v-if="
              row.isEdit &&
                auth.govProjectRecordUpdate &&
                auth.govProjectRecordUpdate.toggleStatus
            "
            v-model="row.content"
            placeholder="请输入跟进信息"
            @blur="handleBlur(row)"
          >
          </el-input>
          <span v-else @click="handleEdit(row)" style="cusor: pointer">{{
            row.content
          }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="gmtCreated"
        label="创建时间"
        width="150"
        align="center"
      >
        <template slot-scope="{ row }">
          <span v-if="row.gmtCreated">{{
            row.gmtCreated | formatTimeFull
          }}</span>
          <span v-else>{{ row.gmtCreated }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="createdName"
        width="80"
        label="创建人"
        align="center"
      >
      </el-table-column>
      <el-table-column width="80" align="center" label="操作">
        <template slot-scope="{ row }">
          <el-button
            v-if="
              auth.govProjectRecordDelete &&
                auth.govProjectRecordDelete.toggleStatus
            "
            @click="delFollow(row)"
            type="text"
            size="small"
          >
            删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 客户列表分页 -->
    <div class="pageination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="pagenation.pageNumber"
        :page-sizes="[10, 20, 50, 100, 200]"
        :page-size="pagenation.pageSize"
        layout="total, sizes, prev, pager, next"
        :total="(proFollowData && proFollowData.totalCount) || 0"
      >
      </el-pagination>
    </div>
    <div slot="footer" class="dialog-footer">
      <crm-button :buttonType="'plain'" :text="'取消'" @click="$emit('close')">
      </crm-button>
      <crm-button :text="'确定'" @click="$emit('close')"></crm-button>
    </div>
  </el-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import CrmButton from '@/components/base/crmButton';
import { formatTimeFull } from '@/scripts/utils';

export default {
  components: {
    CrmButton,
  },
  props: {
    id: String,
    visible: Boolean,
  },
  data() {
    return {
      loading: false,
      diaVisible: false,
      pagenation: {
        pageSize: 10,
        pageNumber: 1,
      },
      list: [],
    };
  },
  computed: {
    ...mapGetters({
      auth: 'authority/auth',
      proFollowData: 'customer/proFollowData',
    }),
  },
  watch: {
    visible(val) {
      this.diaVisible = val;
      if (val) this.handleGetListData();
    },
  },
  methods: {
    ...mapActions({
      getProFollowList: 'customer/getProFollowList',
      addProject: 'customer/addProject',
      deleteProjectFollow: 'customer/deleteProjectFollow',
      addProjectFollow: 'customer/addProjectFollow',
      editProjectFollow: 'customer/editProjectFollow',
    }),
    handleClose() {
      this.$emit('close');
    },
    handleAdd() {
      this.list.unshift({ content: null, isEdit: true });
    },
    handleBlur(row) {
      if (!row.content) {
        this.$message.error('请输入内容');
        return;
      }
      if (row.id) {
        this.editProjectFollow({
          govProjectId: this.id,
          content: row.content,
          id: row.id,
        }).then(() => {
          this.handleGetListData();
        });
      } else {
        this.addProjectFollow({
          govProjectId: this.id,
          content: row.content,
        }).then(() => {
          this.pagenation.pageNumber = 1;
          this.handleGetListData();
        });
      }
    },
    handleEdit(row) {
      const index = this.list.findIndex(item => item.id === row.id);
      this.list[index].isEdit = true;
    },
    delFollow(row) {
      this.$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.deleteProjectFollow({ id: row.id })
            .then(() => {
              this.handleGetListData();
              this.$message({
                type: 'success',
                message: '删除成功!',
              });
            })
            .catch(() => {});
        })
        .catch(() => {});
    },
    handleGetListData() {
      this.loading = true;
      this.getProFollowList({
        govProjectId: this.id,
        ...this.pagenation,
      })
        .then(() => {
          this.list = this.proFollowData.results;
          this.list.forEach((item) => {
            this.$set(item, 'isEdit', false);
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleSizeChange(val) {
      this.pagenation.pageSize = val;
      this.pagenation.pageNumber = 1;
      this.handleGetListData();
    },
    handleCurrentChange(val) {
      this.pagenation.pageNumber = val;
      this.handleGetListData();
    },
  },
  filters: {
    formatTimeFull,
  },
};
</script>

<style></style>
